function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 4a2 2 0 012-2h6l6 6v12a2 2 0 01-2 2H8a2 2 0 01-2-2V4z",
  fill: "#50A26B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 7l6 5V8l-6-1z",
  fill: "#408357"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 6.5V2l6 6h-4.5A1.5 1.5 0 0114 6.5z",
  fill: "#9DCFB3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.4 12.5a.1.1 0 01.1-.1h7a.1.1 0 01.1.1v5.816a.1.1 0 01-.1.1h-7a.1.1 0 01-.1-.1V12.5z",
  stroke: "#fff",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9 14h8v.8H9V14zM9 16h8v.8H9V16z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 12h.8v6.5h-.8V12z",
  fill: "#fff"
});

var SvgExcel = function SvgExcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excel.ef27df54.svg";
export { ForwardRef as ReactComponent };